import ConfigManager from '@/config/ConfigManager.js'
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
import { AccountModel } from "../model/AccountModel.js";

export default {
    apiLoginFacebook: function (params) {
        // let url = ConfigManager.getApiModuleUrl() + '/main/mock_facebook';
        let url = ConfigManager.getApiUrl() + '/auth/login';
        // let params = {
        //     id_token: fbToken,
        // };
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map((res) => {
            let accountModel = new AccountModel();
            accountModel.setDataFromApi(res.data);
            return accountModel;
        }));
    },
}
